import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const portalPartnerMutations: UpdatesConfig['Mutation'] = {
  partnerRoleCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('partnerRoles', cache);
  },
  partnerRoleDelete: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('partnerRoles', cache);
  },
  partnerCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('partners', cache);
  },
  portalContactCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('portalContacts', cache);
  },
  partnerAddContact: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('portalContacts', cache);
  },
  partnerRemoveContact: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('portalContacts', cache);
  },
};

export default portalPartnerMutations;
